<template>
  <div class="sidebar-wrapper-docs" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar :background-color="sidebarBackground" short-title="Canplast" title="Canplast">
      <div
        v-if="nuevosclientes >= 1 && (user.email == 'lizbetharmenta@canplast.com.mx' || user.email == 'aideehernandez@canplast.com.mx' || user.email == 'alfredoreyes@canplast.com.mx' || user.email == 'alonsosalcido@canplast.com.mx' || user.email == 'dannasandoval@canplast.com.mx' || user.email == 'darinkahernandez@canplast.com.mx' || user.email == 'federicoflores@canplast.com.mx' || user.email == 'danielamuniz@canplast.com.mx' || user.email == 'dayanescobar@canplast.com.mx' || user.email == 'claragonzalez@canplast.com.mx' || user.email == 'bereniceterrazas@canplast.com.mx')">
        <center>
          <base-button type="warning" outline @click="analyticsLogEvent('button_id', '0_nuevos_clientes'); $router.push('/nuevocliente');">
            {{ nuevosclientes }} <span>{{nuevosclientes=== 1 ? 'Nuevo cliente':'Nuevos clientes'}}</span>
          </base-button>
        </center>
      </div>
      

      <div
        v-if="nuevosclientes == 0 && (user.email == 'lizbetharmenta@canplast.com.mx' || user.email == 'aideehernandez@canplast.com.mx' || user.email == 'alfredoreyes@canplast.com.mx' || user.email == 'alonsosalcido@canplast.com.mx' || user.email == 'dannasandoval@canplast.com.mx' || user.email == 'darinkahernandez@canplast.com.mx' || user.email == 'federicoflores@canplast.com.mx' || user.email == 'danielamuniz@canplast.com.mx' || user.email == 'dayanescobar@canplast.com.mx' || user.email == 'claragonzalez@canplast.com.mx' || user.email == 'bereniceterrazas@canplast.com.mx')">
        <center>
          <h5>No hay nuevos clientes</h5>
        </center>
      </div>

      <template slot="links">
        <div @click="analyticsLogEvent('button_id', '0_inicio')">
          <sidebar-item :link="{
            name: 'INICIO',
            icon: 'ni ni-tv-2 text-red',
            path: '/inicio',
          }"/>
        </div>

        <div @click="analyticsLogEvent('button_id', '0_ruteador')">
          <sidebar-item :link="{
            name: 'RUTEADOR',
            icon: 'fas fa-truck-pickup text-red',
            path: '/ruteador',
          }" />
        </div>
        
        <div @click="analyticsLogEvent('button_id', '0_pod')">
          <sidebar-item :link="{
            name: 'POD',
            icon: 'ni ni-delivery-fast text-red',
            path: '/pod',
          }" />
        </div>

        <div @click="analyticsLogEvent('button_id', '0_crm')">
          <sidebar-item :link="{
            name: 'CRM',
            icon: 'far fa-handshake text-red',
            path: '/crm',
          }" />
        </div>
        <div @click="analyticsLogEvent('button_id', '0_fulfillment')">
          <sidebar-item :link="{
            name: 'CUMPLIMIENTO',
            icon: 'fas fa-check text-red',
            path: '/cumplimiento',
          }" />
        </div>
        <div @click="analyticsLogEvent('button_id', '0_fulfillment')">
          <sidebar-item :link="{
            name: 'PEDIDOS PENDIENTES',
            icon: 'far fa-folder-open text-red',
            path: '/pedidos-pendientes',
          }" />
        </div>
        <div @click="analyticsLogEvent('button_id', '0_facturacion')">
          <sidebar-item :link="{
            name: 'FACTURACIÓN',
            icon: 'fas fa-file-invoice-dollar text-red',
            path: '/invoicing',
          }" />
        </div>

        <div @click="analyticsLogEvent('button_id', '0_crear_nc')">
          <sidebar-item :link="{
            name: 'CREAR N.C.',
            icon: 'fas fa-file-invoice text-red',
            path: '/returnRequests',
          }" />
        </div>

        <div @click="analyticsLogEvent('button_id', '0_backlog')">
          <sidebar-item :link="{
            name: 'BACKLOG',
            icon: 'fas fa-sync-alt text-red',
            path: '/backlog',
          }" />
        </div>

        <div @click="analyticsLogEvent('button_id', '0_solicitud_credito')">
          <sidebar-item :link="{
            name: 'SOLICITUD CRÉDITO',
            icon: 'fas fa-money-check-alt text-red',
            path: '/solicitudcredito',
          }" />
        </div>

        <div @click="analyticsLogEvent('button_id', '0_fichas_tecnicas')">
          <sidebar-item :link="{
            name: 'FICHAS TÉCNICAS',
            icon: 'fas fa-file-alt text-red',
            path: '/fichastecnicas',
          }" />
        </div>

        <div @click="analyticsLogEvent('button_id', '0_claves_autorizacion')">
          <sidebar-item v-if="
            user.email === 'omarandresgarza@canplast.com.mx' ||
            user.email === 'ofelialujan@canplast.com.mx' ||
            user.email === 'danielamuniz@canplast.com.mx' ||
            user.email === 'darinkahernandez@canplast.com.mx' ||
            user.email === 'dannasandoval@canplast.com.mx' ||
            user.email === 'brendaterrazas@canplast.com.mx' ||
            user.email === 'alfredoreyes@canplast.com.mx' ||
            user.email === 'lizethflores@canplast.com.mx'  ||
            user.email === 'aideehernandez@canplast.com.mx' ||
            user.email === 'estefaniasalas@canplast.com.mx' ||
            user.email === 'marisolmarin@canplast.com.mx' || 
            user.email === 'idalyvillalobos@canplast.com.mx'"
            :link="{
              name: 'CLAVES DE AUTORIZACION',
              icon: 'fas fa-key text-red',
              path: '/passwordGenerator',
            }" 
          />
        </div>

        <div @click="analyticsLogEvent('button_id', '0_cobros')">
          <sidebar-item v-if="
            user.email === 'omarandresgarza@canplast.com.mx' ||
            user.email === 'brendaterrazas@canplast.com.mx' ||
            user.email === 'alfredoreyes@canplast.com.mx' ||
            user.email === 'dannasandoval@canplast.com.mx' ||
            user.email === 'darinkahernandez@canplast.com.mx' ||
            user.email === 'estefaniasalas@canplast.com.mx' ||
            user.email === 'idalyvillalobos@canplast.com.mx' ||
            user.email === 'marisolmarin@canplast.com.mx' ||
            user.email === 'danielamuniz@canplast.com.mx' ||
            user.email === 'leslysifuentes@canplast.com.mx' ||
            user.email === 'carmencoutino@canplast.com.mx' ||
            user.email === 'nallelygonzalez@canplast.com.mx' ||
            user.email === 'ceciliarodea@canplast.com.mx' ||
            user.email === 'guadalupemunoz@canplast.com.mx' ||
            user.email === 'claragonzalez@canplast.com.mx' ||
            user.email === 'facturacionmex@canplast.com.mx' ||
            user.email === 'alexamendez@canplast.com.mx' ||
            user.email === 'angelicapatricio@canplast.com.mx' ||
            user.email === 'citlaliherrera@canplast.com.mx' ||
            user.email === 'yolandachable@canplast.com.mx' ||
            user.email === 'bereniceterrazas@canplast.com.mx' ||
            user.email === 'dayanescobar@canplast.com.mx' ||
            user.email === 'bereniceterrazas@canplast.com.mx' ||
            user.email === 'misaelrobles@canplast.com.mx'
          "
            :link="{
            name: 'COBROS',
            icon: 'fas fa-money-check-alt text-red',
            path: '/cobros',
          }" />
        </div>

        <div @click="analyticsLogEvent('button_id', '0_plan_produccion')">
        <sidebar-item :link="{
          name: 'PLAN DE PRODUCCIÓN',
          icon: 'fas fa-industry text-red',
          path: '/produccion',
        }" />
        </div>

        <!-- Permissions added to certain users -->

        <div @click="analyticsLogEvent('button_id', '0_compras')">
          <sidebar-item menu:true :link="{
            name: 'COMPRAS',
            icon: 'fas fa-shopping-bag text-red',
            path: '/purchase_orders'
          }" />
        </div>

        <!-- <div @click="analyticsLogEvent('button_id', '0_ticket_soporte')">
          <sidebar-item :link="{
            name: 'CREA UN TICKET DE SOPORTE',
            icon: 'fas fa-ticket-alt text-red',
            path: '/support',
          }" />
        </div> -->

        <div @click="analyticsLogEvent('button_id', '0_manual_operacion')">
          <sidebar-item :link="{
            name: 'MANUALES DE OPERACIÓN',
            icon: 'fas fa-file-alt text-red',
            path: '/manuales',
          }" />
        </div>
        
        <div @click="analyticsLogEvent('button_id', '0_extrusion')">
          <sidebar-item :link="{
            name: 'EXTRUSIÓN',
            icon: 'fas fa-industry text-red',
            path: '/extrusion',
          }"/>
        </div>
        
        <div @click="analyticsLogEvent('button_id', '0_requisiciones')" v-if="purchaseReqPermission">
          <sidebar-item :link="{
            name: 'REQUISICIONES DE COMPRA',
            icon: 'fas fa-shopping-cart text-red',
            path: '/requisiciones',
          }"/>
        </div>

        <div @click="analyticsLogEvent('button_id', '0_checador')"
          v-if="[
            'leslysifuentes@canplast.com.mx', 
            'alfredoreyes@canplast.com.mx', 
            'susanajuarez@canplast.com.mx', 
            'mariagarcia@canplast.com.mx',
            'ofelialujan@canplast.com.mx'
          ].includes(user.email)"  
        >
          <sidebar-item :link="{
            name: 'CHECADOR',
            icon: 'fas fa-clock text-red',
            path: '/checador',
          }"/>
        </div>

        <div @click="analyticsLogEvent('button_id', '0_recursos')">
          <sidebar-item :link="{
            name: 'RECURSOS GRÁFICOS',
            icon: 'fa solid fa-image text-red',
            path: '/recursos-graficos',
          }"/>
        </div>

        <div @click="analyticsLogEvent('button_id', '0_muestrarios')">
          <sidebar-item :link="{
            name: 'MUESTRARIOS',
            icon: 'fa solid fa-swatchbook text-red',
            path: '/muestrarios',
          }"/>
        </div>

      </template>


    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition
  },
  beforeMount() {
    const auth = getAuth();
    this.user = auth.currentUser;
    heap.identify(this.user.uid);
    heap.addUserProperties({
      Name: this.user.displayName,
      Email: this.user.email,
    });

    const db = getFirestore();
    const requisitionsQuery = query(
      collection(db, "purchase_requisitions_users"),
      where("email", "==", this.user.email)
    );
    getDocs(requisitionsQuery).then((querySnapshot) => {
      if (!querySnapshot.empty) {
        this.purchaseReqPermission = true;
      }
    });
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      user: null,
      tableData: [],
      nuevosclientes: 0,
      collapseShopping: false,
      FACT_NC: [
        'leslysifuentes@canplast.com.mx', 
        'alfredoreyes@canplast.com.mx', 
        'estefaniasalas@canplast.com.mx',
        'brendaterrazas@canplast.com.mx',
        'idalyvillalobos@canplast.com.mx',
        'reynachavez@canplast.com.mx',
        'edwinpuc@canplast.com.mx',
        'carloshernandez@canplast.com.mx',
        'josesilva@canplast.com.mx',
        'salvadorbarbosa@canplast.com.mx',
        'evelynloera@canplast.com.mx',
        'leonardosantos@canplast.com.mx',
        'operacionesmid@canplast.com.mx',
        'cesarhuerta@canplast.com.mx',
        'lizethflores@canplast.com.mx',
        'ofelialujan@canplast.com.mx'
      ],
      FACT: [
        'juanlopez@canplast.com.mx',
        'octaviojuarez@canplast.com.mx',
        'arielescobedo@canplast.com.mx',
        'cinthyaenciso@canplast.com.mx',
        'franciscoherrera@canplast.com.mx',
        'reynachavez@canplast.com.mx',
        'kevincortes@canplast.com.mx'
      ],
      NC:[
        'bereniceterrazas@canplast.com.mx',
        'jesusaguilar@canplast.com.mx',
        'darinkahernandez@canplast.com.mx',
        'dannasandoval@canplast.com.mx'
      ],
      purchaseReqPermission: false
    };
  },
  mounted() {
    const db = getFirestore();
    const nuevosClientesCollection = collection(db, "NuevosClientes");
    getDocs(nuevosClientesCollection).then((querySnapshot2) => {
      this.nuevosclientes = querySnapshot2.size;
    });
    

  },
  methods: {
    collapseShop() {
      this.collapseShop = true
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    analyticsLogEvent(type, id) {
      //firebase.analytics().logEvent(type, { id: id });
    }
  },
};
</script>
<style lang="scss">
</style>
